function StepTabs({ steps = [], current = 1, onStepChange = null, labels = {} }) {
  return (
    <div className={`step-tabs steps-${steps.length}`} role="tablist" aria-label="Form steps">
      {steps.map((stepNumber, index) => (
        <button
          key={stepNumber}
          type="button"
          className={`step-tab ${current === stepNumber ? 'active' : ''} ${current > stepNumber ? 'done' : ''}`}
          role="tab"
          aria-selected={current === stepNumber}
          onClick={onStepChange ? () => onStepChange(stepNumber) : undefined}
          disabled={!onStepChange}
        >
          <span className="step-pill">{stepNumber}</span>
          <span className="step-label">{labels[stepNumber] || `Step ${stepNumber}`}</span>
          {index < steps.length - 1 ? <span className="step-divider" aria-hidden="true" /> : null}
        </button>
      ))}
    </div>
  );
}

export default StepTabs;
